import { Component } from 'react'
import { Button } from 'dsm-react-lib'
import { staticAssetsPath } from '../configs/constants'
import { useSasToken } from '../_hooks/useSasToken'
import { appInsights } from '../_services/AppInsights'
import { EventType } from '../utility/types'
import { BrandLogo, MiscWrapper } from '../styles/common'
import { useThemeManager } from '../_hooks/useThemeManager'

// Functional component for the error UI (can use hooks)
const ErrorFallback = () => {
  const { appendToken } = useSasToken()
  const { isDarkTheme } = useThemeManager()

  return (
    <MiscWrapper className="bg-white">
      <BrandLogo href="/">
        <img
          alt="img"
          width={'180px'}
          src={
            isDarkTheme
              ? appendToken(`${staticAssetsPath}/images/logo/Centrali-Portal-dark.svg`)
              : appendToken(`${staticAssetsPath}/images/logo/Centrali-Portal.svg`)
          }
        />
      </BrandLogo>
      <div className="p-sm-3">
        <div className="w-100 text-center">
          <h2 className="mb-1 font-bold">Oh no! 🥺</h2>
          <p className="mb-2">{`Something went wrong, please try again later.`}</p>
          <a href="/" className="d-flex justify-content-center">
            <Button label=" Back to home" color="primary" className="btn-sm-block mb-2" />
          </a>
          <div>
            <img
              className="h-[500px]"
              src={appendToken(`${staticAssetsPath}/images/pages/something-went-wrong.png`)}
              alt="Something_went_wrong"
            />
          </div>
        </div>
      </div>
    </MiscWrapper>
  )
}

// Error Boundary must remain a class component (React limitation)
export class ErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to Application Insights
    appInsights.trackEvent({
      name: EventType.ErrorBoundary,
      properties: {
        error: error.message,
        errorInfo
      }
    })
    console.error('error', error, errorInfo?.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />
    }

    return this.props.children
  }
}
